import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import HeroRewards from "@/pages/HeroRewards";

export const Route = createFileRoute("/hero-rewards")({
  head: () => seoHead("/hero-rewards"),
  component: HeroRewards,
});
